<template>
  <div class="pt-editor-help__route-create">
    <div class="pt-editor-help__tips">
      <div class="pt-editor-help__block">
        <b>ЛКМ</b> - выбор местоположения и создание точек маршрута
      </div>
      <div class="pt-editor-help__block">
        <b>Enter</b> - завершить создание маршрута
      </div>
      <div class="pt-editor-help__block">
        <b>Escape</b> - отмена создания маршрута
      </div>
    </div>
    <div class="pt-editor-help__image-block">
      <img
        v-if="theme === 'dark-theme'"
        class="pt-editor-help__image"
        src="../../../../../assets/images/public-transport/routes_create_dark.gif"
      />
      <img
        v-else
        class="pt-editor-help__image"
        src="../../../../../assets/images/public-transport/routes_create_light.gif"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: ["theme"]
};
</script>

<style></style>
